import { Tabs } from "@/components";

import BulkImport from "./BulkImport";
import BulkShift from "./BulkShift";

export default [
    Tabs.createTab("Bulk Shift", BulkShift),
    Tabs.createTab("Bulk Import", BulkImport),
];
